import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SessionValue } from './SessionValue';
import { USER_TOKEN_STORAGE_KEY } from '../constants';
export class SessionTokenStorage {
  constructor(tokenStorageKey = USER_TOKEN_STORAGE_KEY) {
    _defineProperty(this, "token", void 0);
    _defineProperty(this, "tokenStorageKey", void 0);
    _defineProperty(this, "getToken", () => this.token.get() ?? null);
    _defineProperty(this, "setToken", tokenData => {
      this.token.set(tokenData);
      return this;
    });
    this.tokenStorageKey = tokenStorageKey;
    this.token = this.createStorageItem();
  }
  createStorageItem() {
    return new SessionValue(this.tokenStorageKey);
  }
}
//# sourceMappingURL=SessionTokenStorage.js.map